import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { ErrorDTO, DefaultDTO } from '../../dto'
import { store } from '../../store'
import { BASE_ACTIONS, BASE_METHODS } from '../base/base.constants'
import { FORGOTTEN_PASSWORD_ACTIONS } from './users.constants'
import { createCall } from '../base'
import { Language } from '../../enum/language.enum'

export const forgotPassword = async () => {
    store.dispatch({ type: FORGOTTEN_PASSWORD_ACTIONS.FORGOTTEN_PASSWORD_STARTED })

    const body = JSON.stringify({
        email: store.getState().forgotPassword.form.email.value,
    })

    const promise = createCall(`users/forgot-password`, false, BASE_METHODS.POST, body, { Language: Language.fromLanguageCode(navigator.language) })
    promise
        .then(async (response) => {
            let body: DefaultDTO

            try {
                body = plainToClass(DefaultDTO, JSON.parse(await response.text()))
            } catch (exception) {
                store.dispatch({ type: BASE_ACTIONS.ERROR_INVALID_JSON })
                return
            }

            if ((await validate(body)).length > 0) {
                store.dispatch({ type: BASE_ACTIONS.ERROR_INVALID_RESPONSE })
                return
            }

            store.dispatch({ type: FORGOTTEN_PASSWORD_ACTIONS.FORGOTTEN_PASSWORD_OK })

            store.dispatch({ type: BASE_ACTIONS.CLEAR_ERROR })
        })
        .catch(async (response) => {
            let error: ErrorDTO

            try {
                error = plainToClass(ErrorDTO, JSON.parse(await response.text()))
            } catch (exception) {
                //store.dispatch({ type: response })
                return
            }

            store.dispatch({ type: FORGOTTEN_PASSWORD_ACTIONS.FORGOTTEN_PASSWORD_FAILED })

            store.dispatch({ type: BASE_ACTIONS.ERROR_MESSAGE, message: error.message, code: error.code })
        })
}
